export default {
    openerOrigin: '',
    bind() {
        window.addEventListener('message', e => {
            let { type, data } = e.data
            if (type == 'echo') {
                this.openerOrigin = e.origin
            }
        })
        window.opener.postMessage({ type: 'echo' }, '*')
    },
    send(data, type) {
        window.opener.postMessage({ type, data }, this.openerOrigin)
    }

}